module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register"
  }, [_c('div', {
    staticClass: "login-wrapper"
  }, [_c('div', {
    staticClass: "r con-wrap"
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("注册新账号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "邮箱"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telphone),
      expression: "telphone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "手机号"
    },
    domProps: {
      "value": (_vm.telphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telphone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "yz clearfix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "yz-inp",
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sent",
    on: {
      "click": _vm.sendyzm
    }
  }, [_vm._v(_vm._s(_vm.sendMsg))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeshow),
      expression: "codeshow"
    }],
    staticClass: "jtocode"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorShow),
      expression: "errorShow"
    }],
    staticClass: "wrong"
  }, [_vm._v(_vm._s(_vm.errorMsg))]), _vm._v(" "), _c('div', {
    staticClass: "read"
  }, [_c('span', [_c('label', {
    attrs: {
      "for": "sel"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onoff),
      expression: "onoff"
    }],
    attrs: {
      "type": "checkbox",
      "name": "",
      "id": "sel"
    },
    domProps: {
      "checked": Array.isArray(_vm.onoff) ? _vm._i(_vm.onoff, null) > -1 : (_vm.onoff)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.onoff,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.onoff = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.onoff = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.onoff = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "selbox",
    class: _vm.onoff ? 'active' : ''
  }), _vm._v("阅读并同意\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "col",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.alertFn($event)
      }
    }
  }, [_vm._v("《图灵用户协议》")])])]), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("注册")])])]), _vm._v(" "), _c('agreement', {
    attrs: {
      "alertshow": _vm.alertshow
    },
    on: {
      "close": _vm.close,
      "agree": _vm.agree,
      "unagree": _vm.unagree
    }
  }), _vm._v(" "), _c('successalert', {
    attrs: {
      "show": _vm.show,
      "msg": _vm.msg
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f28f08d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/register.vue
// module id = 110
// module chunks = 1